import { AssignmentTurnedInOutlined } from "@mui/icons-material";
import { Stack } from "@mui/material";
import type { FormSubmissionDetailDto } from "src/http";
import { ActionItemLabel } from "..";
import { ItemProperty } from "../itemProperties";

interface Props {
  formSubmission: FormSubmissionDetailDto;
}

const FormSubmissionReferencedStrategicItemsProperty = (props: Props) => {
  return (
    <ItemProperty labelIcon={<AssignmentTurnedInOutlined />} label="Referenced Strategic Items">
      <Stack spacing={0.5}>
        {props.formSubmission.referencedActionItems.map((actionItem) => (
          <ActionItemLabel
            key={actionItem.actionItemGuid}
            actionItemGuid={actionItem.actionItemGuid}
            actionItemDescription={actionItem.description}
            actionItemStatus={actionItem.status}
            actionItemTeam={actionItem.team}
          />
        ))}
      </Stack>
    </ItemProperty>
  );
};

export { FormSubmissionReferencedStrategicItemsProperty };
